import { DisplayStrategyConfig } from './src-constants-priceDisplayStrategy.js';

function getPresentationType(isPpagTailProductPage, displayStrategy, pageId) {
  if (isPpagTailProductPage) {
    return displayStrategy;
  }
  const configStrategy = pageId ? DisplayStrategyConfig[pageId]?.current : void 0;
  return configStrategy ?? displayStrategy;
}

export { getPresentationType };
//# sourceMappingURL=src-util-getPresentationType.js.map
